var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.765 1.265C.5 2.531.5 4.567.5 8.64v.72c0 4.073 0 6.11 1.265 7.375C3.031 18 5.067 18 9.14 18h.72c4.073 0 6.11 0 7.375-1.265C18.5 15.469 18.5 13.433 18.5 9.36v-.72c0-4.073 0-6.11-1.265-7.375C15.969 0 13.933 0 9.86 0h-.72C5.067 0 3.03 0 1.765 1.265Zm1.773 4.21c.097 4.68 2.437 7.492 6.54 7.492h.232V10.29c1.508.15 2.647 1.253 3.105 2.678h2.13c-.585-2.13-2.123-3.308-3.082-3.758.96-.555 2.31-1.905 2.632-3.735H13.16c-.42 1.485-1.665 2.835-2.85 2.963V5.475H8.375v5.19c-1.2-.3-2.715-1.755-2.782-5.19H3.538Z",
    fill: "#0069FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.bdf978f37d66000f0a2e6d12ed256562.svg";
export { ForwardRef as ReactComponent };